import { useMutation } from 'react-query';
import useAxiosPrivate from './useAxiosPrivate';

export const useRequestOTP = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    (data) => {
      return axiosPrivate.post('/register/ckyc/request-otp', data);
    },
    { onSuccess, onError }
  );
};

export const useValidateOTP = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    (data) => {
      return axiosPrivate.post('/register/ckyc/validate-otp', data);
    },
    { onSuccess, onError }
  );
};

export const useResendOTP = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    (data) => {
      return axiosPrivate.post('/register/ckyc/request-otp', data);
    },
    { onSuccess, onError }
  );
};
